(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-cart-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-cc-wa-phone]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const panel = link.closest('[data-cc-cart-wa]');
    if (!panel) return;
    event.preventDefault();
    if (panel.getAttribute('aria-busy') === 'true') return;
    panel.setAttribute('aria-busy', 'true');
    const status = panel.querySelector('.cc-cart-wa__status');
    status.textContent = '';
    try {
      const response = await fetch(panel.dataset.root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!cart.items.length) { status.textContent = panel.dataset.empty; return; }
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {style:'currency',currency:cart.currency}).format(cents / 100);
      const lines = [panel.dataset.intro, ''];
      for (const item of cart.items) {
        lines.push(`${item.quantity} × ${item.title}${item.sku ? ' | SKU: ' + item.sku : ''} | ${money(item.final_line_price)}`);
        for (const [name, value] of Object.entries(item.properties || {})) {
          if (!name.startsWith('_') && value) lines.push(`${name}: ${value}`);
        }
        lines.push(new URL(item.url, location.origin).href, '');
      }
      lines.push(`${panel.dataset.total}: ${money(cart.total_price)} ${cart.currency}`);
      if (cart.note) lines.push(`${panel.dataset.note}: ${cart.note}`);
      lines.push('', panel.dataset.confirm);
      location.assign('https://wa.me/' + link.dataset.ccWaPhone + '?text=' + encodeURIComponent(lines.join('\n')));
    } catch {
      status.textContent = panel.dataset.error;
    } finally {
      panel.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-shipping-progress')) {
    customElements.define('cc-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.version = 0;
        this.onUpdate = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.refresh(), 120);
        };
        document.addEventListener('cart:update', this.onUpdate, { signal: this.controller.signal });
        document.addEventListener('discount:update', this.onUpdate, { signal: this.controller.signal });
        this.refresh();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller.abort();
      }
      async refresh() {
        const version = ++this.version;
        try {
          const root = this.dataset.root || '/';
          const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', {
            headers: { Accept: 'application/json' },
            signal: this.controller.signal,
            cache: 'no-store'
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (version !== this.version || !this.isConnected) return;
          this.hidden = cart.currency !== 'MXN';
          if (this.hidden) return;
          const target = Number(this.dataset.threshold);
          const remaining = Math.max(0, target - cart.total_price);
          const percent = Math.min(100, Math.max(0, cart.total_price / target * 100));
          const amount = new Intl.NumberFormat('es-MX', {
            style: 'currency', currency: 'MXN', maximumFractionDigits: 2
          }).format(remaining / 100);
          const message = cart.item_count === 0 ? this.dataset.empty : remaining === 0 ? this.dataset.complete :
            (percent >= 80 ? this.dataset.near : this.dataset.remaining).replace('__AMOUNT__', amount);
          const text = this.querySelector('.cc-shipping__message');
          if (text.textContent.trim() !== message) text.textContent = message;
          this.querySelector('.cc-shipping__fill').style.width = percent + '%';
          this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.round(percent));
          this.classList.toggle('cc-shipping--complete', remaining === 0);
          this.querySelector('.cc-shipping__icon').textContent = remaining === 0 ? '✓' : '🚚';
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
